<template>
	<nav class="card">
		<!-- <header class="card-header pepms-header">
			<p class="title is-4">Modules</p>
		</header>-->
		<div class="sidebar">
			<aside class="menu">
				<p class="menu-label">Algemeen</p>
				<ul class="menu-list">
					<li v-if="this.user.tbl_sys_role.id == 4">
						<router-link to="/okrvoorzitter">OKR</router-link>
					</li>
					<!-- <li v-if="this.user.tbl_sys_role.id >= 4">
        <router-link to="/objection">Ouders Bezwaar</router-link>
					</li>-->
					<li v-if="this.user.tbl_sys_role.id >= 4">
						<router-link to="/beroepresultaat">Beroep Resultaten</router-link>
					</li>
					<li v-if="this.user.tbl_sys_role.id >= 4">
						<router-link to="/reports">Rapportages</router-link>
					</li>
					<li v-if="this.user.tbl_sys_role.id == 4">
						<router-link to="/eindresultaat">Eindresultaat</router-link>
					</li>
					<li v-if="this.user.tbl_sys_role.id == 4">
						<router-link to="/okrconfig">Aktieve Schooljaar</router-link>
					</li>
					<li v-if="this.user.tbl_sys_role.id == 4">
						<router-link to="/reexam">Herexamens</router-link>
					</li>
					<li v-if="this.user.tbl_sys_role.id == 4">
						<router-link to="/studentreexam">Herexamen Student</router-link>
					</li>
				</ul>
				<p class="menu-label" v-if="this.user.tbl_sys_role.id == 4">Gebruikers</p>
				<ul class="menu-list">
					<li v-if="this.user.tbl_sys_role.id == 4">
						<router-link to="/lock">Administratie</router-link>
					</li>
					<li v-if="this.user.tbl_sys_role.id == 4">
						<router-link to="/roles">Type Gebruikers</router-link>
					</li>

				</ul>
			</aside>
		</div>
	</nav>
</template>
<script>
import Axios from "axios";
import Cookies from "js-cookie";
import { API_ROOT } from "../config";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});
export default {
	name: "sidebar",
	created: function() {
		//this.getUnits()
	},

	data: function() {
		return {
			access: Cookies.get("access"),
			user: Cookies.getJSON("user"),
			tableData: []
		};
	},
	computed: {
		// user() {
		//   return this.$store.getters.getUser;
		// },
		// firstlogin() {
		//   return this.$store.getters.getFirstlogin;
		// }
	},
	methods: {
		handleEdit(index, row) {
			console.log(index, row);
		},
		handleClick(unitcode) {
			console.log("unitcode: " + unitcode);
			this.$router.push({
				path: "unit/" + unitcode
			});
		},
		handleDelete(index, row) {
			console.log(index, row);
		},
		onPagination: function() {}
	}
};
</script>
</script>
<style scoped>
.sidebar {
	padding-left: 12px;
	padding-top: 5px;
	padding-right: 12px;
	padding-bottom: 12px;
}
.pepms-header {
	padding-top: 12px;
	padding-left: 12px;
	padding-bottom: 12px;
}
</style>
